import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { createCloseButton as T } from "../../util/component-utils.js";
import { detectSwipe as K, DIRECTIONS as L } from "../../util/dom-utils.js";
import { _handleBrazeAction as O } from "../../Core/handle-braze-action.js";
import { logCardDismissal } from "../index.js";
import { Guid as P } from "../../../shared-lib/index.js";
export function markCardAsRead(t) {
  if (null != t) {
    var e = t.querySelectorAll(".ab-unread-indicator")[0];
    null == e || e.classList.contains("read") || (e.className += " read");
  }
}
export function getCardId(t) {
  return t.getAttribute("data-ab-card-id");
}
export function _setImageAltText(t, e) {
  e.setAttribute("alt", t.altImageText || "");
}
export function setCardHeight(t, e) {
  var a = e.querySelectorAll(".ab-image-area");
  var o,
    i = 0;
  a.length > 0 && (i = a[0].offsetWidth);
  var _iterator = _createForOfIteratorHelper(t),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e = _step.value;
      if (o = _e._t, o && _e.imageUrl && "number" == typeof _e.aspectRatio) {
        var _t = i / _e.aspectRatio;
        _t && (o.style.height = "".concat(_t, "px"));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
export function cardToHtml(t, e, a) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ltr";
  var i = document.createElement("div");
  i.dir = o, t.language && (i.lang = t.language), i.className = "ab-card ab-effect-card " + t.Xt, t.id && (i.setAttribute("data-ab-card-id", t.id), i.setAttribute("id", t.id)), i.setAttribute("role", "article");
  var n = "",
    d = !1;
  t.url && "" !== t.url && (n = t.url, d = !0);
  var r = function r(o) {
    return markCardAsRead(i), d && (e(t), O(n, a, o)), !1;
  };
  if (t.pinned) {
    var _t2 = document.createElement("div");
    _t2.className = "ab-pinned-indicator";
    var _e2 = document.createElement("i");
    _e2.className = "fa fa-star", _t2.appendChild(_e2), i.appendChild(_t2);
  }
  if (t.imageUrl && "" !== t.imageUrl) {
    var _e3 = document.createElement("div");
    _e3.dir = o, _e3.className = "ab-image-area";
    var _a = document.createElement("img");
    if (_a.setAttribute("src", t.imageUrl), _a.onload = function () {
      i.style.height = "auto";
    }, _setImageAltText(t, _a), _e3.appendChild(_a), i.className += " with-image", d && !t.Yt) {
      var _a2 = document.createElement("a");
      _a2.setAttribute("href", n), _a2.onclick = r, t.altImageText || (t.title ? _a2.setAttribute("aria-label", t.title) : _a2.setAttribute("aria-label", "Feed Image")), _a2.appendChild(_e3), i.appendChild(_a2);
    } else i.appendChild(_e3);
  }
  var c = document.createElement("div");
  if (c.className = "ab-card-body", c.dir = o, t.dismissible) {
    t.logCardDismissal = function () {
      return logCardDismissal(t);
    };
    var _e4 = T("Dismiss Card", void 0, t.dismissCard.bind(t), o);
    i.appendChild(_e4), K(c, L.Zt, function (t) {
      i.className += " ab-swiped-left", _e4.onclick(t);
    }), K(c, L.ae, function (t) {
      i.className += " ab-swiped-right", _e4.onclick(t);
    });
  }
  var s = "",
    m = !1;
  if (t.title && "" !== t.title && (s = t.title, m = !0), m) {
    var _t3 = document.createElement("h1");
    if (_t3.className = "ab-title", _t3.id = P.oe(), i.setAttribute("aria-labelledby", _t3.id), d) {
      var _e5 = document.createElement("a");
      _e5.setAttribute("href", n), _e5.onclick = r, _e5.appendChild(document.createTextNode(s)), _t3.appendChild(_e5);
    } else _t3.appendChild(document.createTextNode(s));
    c.appendChild(_t3);
  }
  var u = document.createElement("div");
  if (u.className = m ? "ab-description" : "ab-description ab-no-title", t.language && (u.lang = t.language), t.description && u.appendChild(document.createTextNode(t.description)), d) {
    var _e6 = document.createElement("div");
    _e6.className = "ab-url-area";
    var _a3 = document.createElement("a");
    _a3.setAttribute("href", n), t.linkText && _a3.appendChild(document.createTextNode(t.linkText)), _a3.onclick = r, _e6.appendChild(_a3), u.appendChild(_e6);
  }
  c.appendChild(u), i.appendChild(c);
  var l = document.createElement("div");
  return l.className = "ab-unread-indicator", t.viewed && (l.className += " read"), i.appendChild(l), t._t = i, i;
}